var _path, _path2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 36 58",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.7227 28.7334c1.8866 0 3.7548-.3716 5.4979-1.0936 1.743-.722 3.3268-1.7802 4.6608-3.1143 1.3341-1.3341 2.3924-2.9179 3.1144-4.6609.7219-1.7431 1.0936-3.6112 1.0936-5.4979s-.3717-3.7549-1.0936-5.49791c-.722-1.74305-1.7803-3.32682-3.1144-4.66089-1.334-1.33407-2.9178-2.39232-4.6609-3.11431-1.743-.721996-3.6112-1.09360035-5.4979-1.09360019l.0001 14.36671019z",
    fill: "#00d563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.7227 57.6875c1.8866 0 3.7548-.3716 5.4979-1.0936 1.743-.722 3.3268-1.7802 4.6608-3.1143 1.3341-1.3341 2.3924-2.9179 3.1144-4.6609.7219-1.7431 1.0936-3.6112 1.0936-5.4979s-.3717-3.7549-1.0936-5.4979c-.722-1.7431-1.7803-3.3268-3.1144-4.6609-1.334-1.3341-2.9178-2.3923-4.6609-3.1143-1.743-.722-3.6112-1.0936-5.4979-1.0936l.0001 14.3667z",
    fill: "#12c6a0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.41507,
    cy: 10.2398,
    fill: "#12c6a0",
    r: 7.41507
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.41507,
    cy: 44.8438,
    fill: "#00d563",
    r: 7.41507
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.a0ec0b6f76bde1efc8cec6d464f422b5.svg";
export { ForwardRef as ReactComponent };